import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {BillingAccountActions} from "../../services/billing-account-actions.service";
import {BillingAccountDialogService} from "../../services/billing-account-dialog-service.service";

export class accountBillingActionsCtrl implements IController {
  id: any
  onActionSuccess: Function;

  private country: any;
  private actions: any;

  /* @ngInject */
  constructor(private billingAccountActions: BillingAccountActions, private splitService, private billingAccountDialogService: BillingAccountDialogService, private $log) {
  }

  $onInit() {
    this.country = this.splitService.getCountryCode();
    this.actions = [
      {name: 'Charge'},
      {name: 'Add Credit'},
      {name: 'Add Debt'},
      {name: 'Create Invoice'},
      {name: 'Create Receipt'},
      {name: 'Create Inverc'},
      {name: 'Create Deal'},
      {name: 'Export'}
    ];

    if (_.isEqual(this.country, 'US')) {
      const invercIndex = _.findIndex(this.actions,(action:any) => {
        return _.isEqual(action.name, 'Create Inverc');
      });
      if (!_.isEqual(invercIndex, -1)) {
        this.actions.splice(invercIndex, 1);
      }
    }

  }

  openDialog(event, name) {
    let functionRef;

    if (_.isEqual(name, 'Charge')) {
      functionRef = this.billingAccountActions.charge(event, this.id);
    }
    if (_.isEqual(name, 'Add Credit')) {
      functionRef = this.billingAccountActions.addCredit(event, this.id);
    }
    if (_.isEqual(name, 'Add Debt')) {
      functionRef = this.billingAccountActions.addDebit(event, this.id);
    }
    if (_.isEqual(name, 'Create Invoice')) {
      functionRef = this.billingAccountActions.createInvoice(event, this.id);
    }
    if (_.isEqual(name, 'Create Receipt')) {
      functionRef = this.billingAccountActions.createReceipt(event, this.id);
    }
    if (_.isEqual(name, 'Create Inverc')) {
      functionRef = this.billingAccountActions.createInverc(event, this.id);
    }
    if (_.isEqual(name, 'Create Deal')) {
      functionRef = this.billingAccountActions.createDeal(event, this.id);
    }
    if (_.isEqual(name, 'Export')) {
      functionRef = this.billingAccountActions.exportBillingTransactions(event, this.id);
    }

    functionRef
      .then(() => {
        this.onActionSuccess();
      })
      .catch(() => {
        this.$log.info('Closed Dialog');
      })
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('accountBillingActions', {
    bindings: {
      id : '<',
      onActionSuccess: '&'
    },
    template: require('./account-billing-actions.html').default,
    controller: accountBillingActionsCtrl
  });

